/* eslint-disable */
export default {
  state: {},
  mutations: {},
  actions: {
  },
  getters: {}
};
